import { apiFetch } from '../api/client'
const cache = new Map()

// Fetches a country's flag image URL (or null) and reports it via callback.
// Cached per country_id so repeated lookups (e.g. while typing a search query) are free.
export function getCountryFlag(countryId, onResult) {
  if (!countryId) {
    onResult(null)
    return
  }
  if (cache.has(countryId)) {
    onResult(cache.get(countryId))
    return
  }
  apiFetch(`/countries/${countryId}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      const url = data?.country_flag_image_url || null
      cache.set(countryId, url)
      onResult(url)
    })
    .catch(() => {
      onResult(null)
    })
}
